import React from "react";
import { Route, Switch } from "react-router-dom";
import AssetsList from "./assetsList";
import AssetsAdd from "./AssetsAdd";
import AssetEdit from "./AssetEdit";
import AssetsColorList from "./AssetsColorList";
import AssetColorAdd from "./AssetColorAdd";
import AssetColorEdit from "./AssetColorEdit";

const designCenterRoutes = (
  <Switch>
    <Route path="/assets/list" component={AssetsList} />
    <Route path="/assets/add" component={AssetsAdd} />
    <Route path="/asset/edit/:assetID?" component={AssetEdit} />
    <Route path="/assets/color/list" component={AssetsColorList} />
    <Route path="/asset/color/add" component={AssetColorAdd} />
    <Route path="/asset/color/edit/:assetColorID?" component={AssetColorEdit} />
  </Switch>
);

export default designCenterRoutes;



// WEBPACK FOOTER //
// ./src/app/views/admin/designCenter/designCenterRoute.js